module.exports = __webpack_public_path__ + "img/car_14.3ae0c327.jpg";